import { createSelector } from 'reselect';

const selectNetworks = (state: any) => state.networks;


export const selectNetworksCurrentItem = createSelector([selectNetworks], (networks) => networks.current);

export const selectNetworksListItems = createSelector([selectNetworks], (networks) => networks.list);

export const selectNetworksItemById = (itemId: any) =>
    createSelector(selectNetworksListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectNetworksQueryItems = createSelector([selectNetworks], (networks) => networks.query);

export const selectNetworksCreatedItem = createSelector([selectNetworks], (networks) => networks.create);

export const selectNetworksUpdatedItem = createSelector([selectNetworks], (networks) => networks.update);

export const selectNetworksReadItem = createSelector([selectNetworks], (networks) => networks.read);

export const selectNetworksDeletedItem = createSelector([selectNetworks], (networks) => networks.delete);

export const selectNetworksearchedItems = createSelector([selectNetworks], (networks) => networks.search);

export const selectNetworksItemsCount = createSelector([selectNetworks], (networks) => networks.count);

export const selectNetworksItemsFilter = createSelector([selectNetworks], (networks) => networks.filter);